import {
  AccountDTO,
  CheckSessionResp,
  SetInitialPasswordReqBody,
  SetPasswordReqBody,
  UserDTO,
} from '@ytl/common-model';
import { getConfig } from '../data/config';
import { axiosInstance } from './axiosInstance';

export const PasswordResource = {
  async checkInitPasswordSessionId(token: string): Promise<CheckSessionResp> {
    return (await axiosInstance.get(`/api/check-session-expiry?token=${token}`)).data;
  },

  async setInitialPassword(token: string, accountId: string, newPassword?: string): Promise<AccountDTO> {
    const res = await axiosInstance.post(
      `/api/set-initial-password`,
      {
        token,
        accountId,
        newPassword,
      },
      { maxRedirects: 0 },
    );

    if (res.headers?.location) {
      window.location.href = res.headers.location;
    }

    return res.data as UserDTO;
  },

  changePassword(params: SetPasswordReqBody, verificatorJwt?: string, phoneNumber?: string): Promise<void> {
    return axiosInstance.post(`/api/change-password`, {
      ...params,
      ...(verificatorJwt ? { verificatorJwt } : {}),
      ...(phoneNumber ? { phoneNumber } : {}),
    });
  },

  forgotPassword(params: SetInitialPasswordReqBody, verificatorJwt?: string, phoneNumber?: string): Promise<void> {
    return axiosInstance.post(`/api/forgot-password`, {
      ...params,
      ...(verificatorJwt ? { verificatorJwt } : {}),
      ...(phoneNumber ? { phoneNumber } : {}),
    });
  },

  sendForgottenPasswordEmail(email: string, captchaToken: string | undefined): Promise<boolean> {
    return axiosInstance.post(`/api/start-forgotten-password`, { email, ct: captchaToken });
  },
  closeWebView() {
    window.location.href = getConfig().closeWebViewUrl;
  },
};
